"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeFirstWord = capitalizeFirstWord;
exports.pascalCase = pascalCase;
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalizeFirstWord(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function pascalCase(str) {
  return str.split('-').map(value => capitalizeFirstWord(value)).join('');
}